import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import 'rxjs/add/operator/map';
import { ApiService } from '../services/api.service';
import { REST_API_REQUEST_CALL_URL } from '../utils/index';
import { Subscription } from 'rxjs';
import { TextString } from "./consults.service";

export class AiUser {
  aiUser:string;
}
export class BlToUnipass {
  cargMtNo: string;
  mblNo:string;
  hblNo: string;
  date:string;
}

export class UnipassData {
  cargCsclPrgsInfoQryRtnVo: CargCsclPrgsInfoQryRtnVo;
}

export class CargCsclPrgsInfoQryRtnVo {
  ntceInfo: any;
  cargCsclPrgsInfoQryVo: any;//CargCsclPrgsInfoQryVo | CargCsclPrgsInfoQryVo[];
  tCnt: TextString;
  cargCsclPrgsInfoDtlQryVo: Array<CargCsclPrgsInfoDtlQryVo>;
};

export class CargCsclPrgsInfoQryVo {
  csclPrgsStts: TextString;
  vydf: TextString;
  rlseDtyPridPassTpcd: TextString;
  prnm: TextString;
  ldprCd: TextString;
  shipNat: TextString;
  blPt: TextString;
  dsprNm: TextString;
  etprDt: TextString;
  prgsStCd: TextString;
  msrm: TextString;
  wghtUt: TextString;
  dsprCd: TextString;
  cntrGcnt: TextString;
  cargTp: TextString;
  shcoFlcoSgn: TextString;
  pckGcnt: TextString;
  etprCstm: TextString;
  shipNm: TextString;
  hblNo: TextString;
  prcsDttm: TextString;
  spcnCargCd: TextString;
  ttwg: TextString;
  ldprNm: TextString;
  dclrDelyAdtxYn: TextString;
  mtTrgtCargYnNm: TextString;
  cargMtNo: TextString;
  cntrNo: TextString;
  mblNo: TextString;
  blPtNm: TextString;
  lodCntyCd: TextString;
  prgsStts: TextString;
  shcoFlco: TextString;
  pckUt: TextString;
  shipNatNm: TextString;
  agnc: TextString;
}

export class CargCsclPrgsInfoDtlQryVo {
  shedNm: TextString;
  prcsDttm: TextString;
  dclrNo: TextString;
  rlbrDttm: TextString;
  wght: TextString;
  rlbrBssNo: TextString;
  bfhnGdncCn: TextString;
  wghtUt: TextString;
  pckGcnt: TextString;
  cargTrcnRelaBsopTpcd: TextString;
  pckUt: TextString;
  rlbrCn: TextString;
  shedSgn: TextString;
  hasCustom:boolean = false;
}

export class UnipassCntrList {
  cntrQryBrkdQryRtnVo: CntrQryBrkdQryRtnVo;
}

export class CntrQryBrkdQryRtnVo {
  cntrQryBrkdQryVo: CntrQryBrkdQryVo;
  ntceInfo: TextString;
  tCnt:TextString;
}

export class CntrQryBrkdQryVo {
  cntrId: number;
  cntrNo: TextString;
  cntrSelgNo1: TextString;
  cntrSelgNo2: TextString;
  cntrSelgNo3: TextString;
  cntrStszCd: TextString;
}

export class EnterPortInfo {
  etprRprtQryBrkdQryRtnVo: EtprRprtQryBrkdQryRtnVo;
}

export class EtprRprtQryBrkdQryRtnVo {
  etprRprtQryBrkdQryVo: EtprRprtQryBrkdQryVo;
  ntceInfo: TextString;
  tCnt: TextString;
}

export class EtprRprtQryBrkdQryVo {
  acptDttm: TextString;
  alCrmbPecnt: TextString;
  alPsngPecnt: TextString;
  cstmSgn: TextString;
  etprDttm: TextString;
  mrn: TextString;
  shipAirCntyCd: TextString;
  shipCallImoNo: TextString;
  shipFlgtNm: TextString;
  shipLamrPlcCd: TextString;
  shipLamrPlcNm: TextString;
}

export class ShedInfo {
  adtxColtPridYn: string;
  jrsdCstmSgn: string;
  jrsdCstmSgnNm: string;
  ldunPlcSnarYn: string;
  pnltLvyTrgtYn: string;
  snarBscsAddr: string;
  snarKoreNm: string;
  snarSgn: string;
  snarTelno: string;
}

export class ShedInfo2 {
  shedInfoQryRtnVo: ShedInfoDetail;
}

export class ShedInfoDetail {
  ntceInfo:TextString;
  shedInfoQryRsltVo: Array<ShedAddress2> | ShedAddress2;
  tCnt: TextString;
}

export class ShedAddress2 {
  snarAddr:TextString;
  snarSgn: TextString;
  snarNm: TextString;
  snartelno: TextString;
}

export class CustInfo {
  lcaBrkdQryRtnVo: LcaBrkdQryRtnVo;
}

export class LcaBrkdQryRtnVo {
  lcaBrkdQryRsltVo:LcaBrkdQryRsltVo;
  ntceInfo: TextString;
  tCnt: TextString;
}

export class LcaBrkdQryRsltVo {
  addr: TextString;
  jrsdCstmNm: TextString;
  lcaConm: TextString;
  lcaSgn: TextString;
  lcaTp: TextString;
  rppnNm: TextString;
  telno: TextString;
}

@Injectable()
export class UnipassService {
    
    constructor(private http: Http, private apiService:ApiService) {
    };

    postBlNoToUnipass(aiUser:string, cargMtNo:string, mblNo: string, hblNo: string, date:string) {
      let body = {
        aiUser: aiUser
      };

      let params = {
        cargMtNo: cargMtNo,
        mblNo: mblNo,
        hblNo: hblNo,
        date:date
      };
      
      return this.apiService.post('unipass/retrieveCargCsclPrgsInfo/v2', body, false, params);
    }

    postCntrList(cargMtNo:string) {
      let params = {  
        cargMtNo: cargMtNo
      };
      
      return this.apiService.post('unipass/cntrQryBrkdQry', null, false, params);
    }

    postEtprRprt(ioprSbmtNo: string) {
      let params = {
        ioprSbmtNo: ioprSbmtNo
      }

      return this.apiService.post('unipass/etprRprtQryBrkdQry', null, false, params);
    }

    postShedInfo(snarSgn: string) {
      let params = {
        snarSgn: snarSgn
      }

      return this.apiService.post('unipass/shedInfoQry', null, false, params);
    }

    postCustInfo(lcaSgn: string) {
      let params = {
        lcaSgn: lcaSgn
      }

      return this.apiService.post('unipass/lcaBrkdQry', null, false, params);
    }



    


  }


// WEBPACK FOOTER //
// ./src/app/services/unipass.service.ts